export default __webpack_public_path__ + "static/map-cb17f2a66e010b7b809fa9ff9ac39dcc.svg";